/* Lucian UX/UI Prompt #092 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#092 */
import './lucian-092.css';

// 원본 조사 선택 함수 그대로 (이/가, 으로/로, 과/와)
const jo = (w, a, b, rieul) => { const c = w.charCodeAt(w.length - 1) - 0xAC00; if (c < 0 || c > 11171) return a + '(' + b + ')'; const t = c % 28; return t === 0 || (rieul && t === 8) ? b : a; };
const ARROW = <svg viewBox="0 0 15 15" aria-hidden="true"><path d="M3 7.5h9M8.5 4l3.5 3.5L8.5 11" /></svg>;

// 원본의 "필터를 빼면 N개"를 프나찾기의 다중 키워드 AND에 대응: "단어를 빼면 N건"
// drops: [{ word, rest, count }]  ·  shorter: { term, count } | null  ·  popular: string[]
export default function LucianNoResults({ query, isImage, drops, shorter, popular, onSearch }) {
  const raw = (query || '').trim();
  let title, sub, mode;
  if (isImage) {
    title = '비슷한 장면을 찾지 못했어요';
    sub = '자막·워터마크가 적고 화면이 크게 보이는 캡처일수록 잘 맞아요';
    mode = 'none';
  } else if (drops.length || shorter) {
    title = `‘${raw}’${jo(raw, '이', '가')} 함께 나온 대사가 없어요`;
    sub = drops.length ? '단어를 하나만 빼도 결과가 나와요' : '조금 짧게 줄이면 결과가 나와요';
    mode = 'drop';
  } else {
    title = `‘${raw}’${jo(raw, '과', '와')} 맞는 대사가 없어요`;
    sub = '더 짧게 줄이거나 멤버 별명으로 찾아보세요';
    mode = 'pop';
  }

  return (
    <div className="ux u092 u092-site" role="status">
      <div className="u092-none">
        <div className="u092-art" aria-hidden="true"><svg viewBox="0 0 150 92"><path className="u092-shelf" d="M8 30h134M8 56h134M8 82h134" /><g className="u092-lens"><circle cx="34" cy="38" r="20" /><path className="gl" d="M24 30a12 12 0 0 1 8-5" /><path d="M48 52l14 14" /></g></svg></div>
        <p className="u092-nt">{title}</p>
        <p className="u092-ns">{sub}</p>
        {mode === 'drop' && (
          <div className="u092-sgs">
            {drops.slice(0, 2).map((d, i) => (
              <button key={d.word} type="button" className="u092-sg" style={{ '--i': i }}
                aria-label={`${d.word} 빼고 검색하면 ${d.count}건`} onClick={() => onSearch(d.rest)}>
                <s>{d.word}</s><span>빼면 <b>{d.count}건</b></span>{ARROW}
              </button>
            ))}
            {shorter && (
              <button type="button" className="u092-sg typo" style={{ '--i': drops.length }}
                aria-label={`${shorter.term}${jo(shorter.term, '으로', '로', true)} 검색하면 ${shorter.count}건`} onClick={() => onSearch(shorter.term)}>
                <span>‘{shorter.term}’{jo(shorter.term, '으로', '로', true)} 찾기 · <b>{shorter.count}건</b></span>{ARROW}
              </button>
            )}
          </div>
        )}
        {mode === 'pop' && (
          <div className="u092-sgs pop">
            {popular.map((w, i) => (
              <button key={w} type="button" className="u092-sg" style={{ '--i': i }} onClick={() => onSearch(w)}>{w}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
